// extracted by mini-css-extract-plugin
export default {"blockchainAnimalOverview":"BlockchainAnimalOverview_blockchainAnimalOverview__ilmxr","spin":"BlockchainAnimalOverview_spin__5IGrs"};